import { it as coreLocalesIt } from "@ob/core";
import { TLanguagesKeys } from "@ob/i18n";
import { it as footerLocalesIt } from "../../components/Footer";
import { it as hookLocales } from "../../hooks/locales";
import { it as pagesLocales } from "../../pages/locales";

const it = {
  ...footerLocalesIt,
  ...coreLocalesIt,
  ...hookLocales,
  ...pagesLocales,
};

export const messages: Record<
  TLanguagesKeys,
  Record<string, string | object>
> = { it };
